<!-- src/app/layout/drawer.html -->
<p-drawer
  [header]="config()?.title || 'Quick Actions'"
  position="right"
  [visible]="isVisible()"
  (onHide)="onDrawerHide()"
  [style]="{ width: config()?.width || '400px' }"
  [modal]="true"
  [dismissible]="true"
  [showCloseIcon]="config()?.showCloseButton !== false"
  [blockScroll]="true"
  [appendTo]="'body'"
  >

  <!-- Dynamic Content Container -->
  <div class="drawer-content">
    <!-- Container for dynamic components/templates -->
    <ng-container #dynamicComponentContainer></ng-container>

    <!-- Fallback content if no dynamic content -->
    @if (!config()) {
      <div class="p-4 text-center">
        <i class="pi pi-inbox text-4xl text-400 mb-3 block"></i>
        <p class="text-600">No content to display</p>
      </div>
    }
  </div>

  <!-- Optional Footer with actions -->
  @if (config()?.actions?.length) {
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        @for (action of config()?.actions; track action) {
          <p-button
            [label]="action.label"
            [icon]="action.icon"
            [severity]="action.severity || 'primary'"
            [disabled]="action.disabled"
            (click)="action.handler()"
            [size]="'small'"
          ></p-button>
        }
      </div>
    </ng-template>
  }
</p-drawer>